import { sizes } from "../../../constants/sizes";
import { useRef } from "react";
import { ReactComponent as HardwareIcon } from "../../../svgs/Hardware.svg";

import { useReactToPrint } from "react-to-print";

const Hardware = ({ project, editProject }) => {

  const { kitName, size } = project;

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <div className="sheet-comp-container">
      <div className="sheet-input">
        <div id="sheet-print-button" onClick={handlePrint}>
          print
        </div>
      </div>
      <div className="sheet-output">
        <div className="sheet-title">
          <div className="sheet-icon-title">
            <HardwareIcon />
            <div>Hardware</div>
          </div>
          <div>
            {kitName} - {sizes[size]}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hardware;
